import { capitalize } from "@core/utils";
import type { ItemCategory } from "@src/types";
import type { NVItem, NVProduct, NVSeller } from "./types";

const AVOID_CATEGORIES = /^(outlet|bazar|sale|coleção|promoção)$/i;

// SKU selecionado: PDP usa selectedItem, shelfes usa o alias sku, senão o primeiro item
export type NVActiveItem = NVItem & {
  image?: { imageUrl: string; imageLabel: string | null };
  seller?: NVSeller;
};

export const getActiveItem = (product: NVProduct): NVActiveItem | undefined => product?.selectedItem ?? product?.sku ?? product?.items?.[0];

export const getDefaultSeller = (item?: NVActiveItem): NVSeller | undefined =>
  item?.seller ??
  item?.sellers?.find((s) => s.sellerDefault) ??
  item?.sellers?.[0];

export const getItemImage = (item?: NVActiveItem): string | undefined => item?.image?.imageUrl ?? item?.images?.[0]?.imageUrl;

export const getVariantColor = (item?: NVActiveItem): string | null => item?.name?.split(" - ")[0]?.replace(/^[^_]+_/, "").replace(/_/g, " ") || null;

export const getVariantSize = (item?: NVActiveItem): string | null => item?.name?.split(" - ")[1]?.toUpperCase() ?? null;

export const getItemCategory = (product: NVProduct): ItemCategory => {
  const categories = product?.categories;
  if (!categories?.length) return "Coleção";

  const match = categories
    .join(" ")
    .match(/outlet|bazar|sale/i)?.[0]
    ?.toLowerCase();
  return (match as ItemCategory) ?? "Coleção";
};

export const getItemCategory2 = (product: NVProduct): string => {
  const path = product?.categories?.[0] ?? ""; // primeiro path = mais específico
  const segments = path
    .split("/")
    .map((segment) => segment.trim())
    .filter((segment) => segment && !AVOID_CATEGORIES.test(segment));
  return capitalize(segments[segments.length - 1]) ?? "";
};
